export default "__VITE_ASSET__DzaLLOid__"